import React from 'react';
import { useTranslation } from 'react-i18next';
import { Stack, IconButton, Typography } from '@mui/material';

import dayjs from 'dayjs';

import EditIcon from '../Icons/EditIcon';
import DeleteIcon from '../Icons/DeleteIcon';
import { BlackCars } from '../../domain/black-cars';

interface Props {
  blackCars: BlackCars;
  onRemove: () => void;
}

export const BlackCarsShoppingCartSummary = ({ blackCars, onRemove }: Props) => {
  const { t } = useTranslation();

  return (
    <Stack gap="16px" padding="16px 0px" direction="column" borderBottom="1px solid rgba(0, 0, 0, 0.12)">
      <Stack direction="column">
        <Stack width="100%" direction="row" alignItems="center" justifyContent="space-between">
          <Typography variant="body1" color="secondary.light" fontWeight={700}>
            {t('black_cars_service.name')}
          </Typography>
          <Stack direction="row">
            {false && (
              <IconButton onClick={onEdit}>
                <EditIcon fontSize="small" />
              </IconButton>
            )}
            <IconButton onClick={onRemove}>
              <DeleteIcon fontSize="small" />
            </IconButton>
          </Stack>
        </Stack>
        <Stack width="100%">
          <Stack width="fit-content">
            <Typography fontSize={12} fontWeight={500}>
              {dayjs(blackCars.filters.date).format('MMMM DD')}
            </Typography>

            <Typography mt={0.5} fontSize={12} fontWeight={500}>
              {blackCars.tixProduct.DsPublic}
            </Typography>

            <Typography mt={0.5} fontSize={14} fontWeight={500}>
              ${blackCars.tixProduct.DisplayAmount.toFixed(2)} {blackCars.tixProduct.DisplayCurrency}
            </Typography>
          </Stack>
        </Stack>
      </Stack>
    </Stack>
  );
};
